import type { PageContext } from 'vike/types';
import { extractPageNumber } from '../../utils/seo/srp-seo-utils';
import { computeSearchPageMeta } from './utils/seoUtils';
import { truncateSeoTitle } from '../../utils/seo/truncate-seo-title';

export default function title(pageContext: PageContext): string {
  const pc = pageContext as any;
  if (!pc) {
    console.warn('[index/+title.ts] pageContext is undefined');
    return 'JobCrawls';
  }
  const url = pc?.urlOriginal || '/';
  const locale = (pc?.locale || 'en') as 'en' | 'fi' | 'sv';

  const { title: metaTitle } = computeSearchPageMeta(pc, locale);
  const pageNum = extractPageNumber(url);

  const getPageSuffix = (page: number, loc: string): string => {
    if (loc === 'fi') return ` (Sivu ${page})`;
    if (loc === 'sv') return ` (Sida ${page})`;
    return ` (Page ${page})`;
  };

  let finalTitle = truncateSeoTitle(metaTitle);
  if (pageNum !== null && pageNum > 1) {
    finalTitle = truncateSeoTitle(finalTitle + getPageSuffix(pageNum, locale));
  }

  return finalTitle;
}
